import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../Notifications/ToastifyActions";

function SaveNotificationTypeLookupService(token, data) {
    const items = Array.isArray(data) ? data : [data];

    return Promise.all(
        items.map((item) =>
            axios.post(
                `${CURRENT_API_URL}/amazonNotifications/saveNotificationTypeLookup`,
                item,
                {
                    headers: {
                        Authorization: token,
                    },
                }
            )
        )
    )
        .then((responses) => {
            const results = responses.map((res) => res.data);
            const allOk = results.every((result) => result && result.status);
            if (!allOk) {
                notify.NotifyError("Unable to save notification setting.");
                return false;
            }
            notify.NotifySuccess("Amazon Notification settings saved successfully.");
            return Array.isArray(data) ? results : results[0];
        })
        .catch((error) => {
            console.log(error);
            notify.NotifyError(
                "Unable to save notification setting."
            );
            return false;
        });
}

export default SaveNotificationTypeLookupService;
